
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/imoveis/[model]",
      function () {
        return require("private-next-pages/imoveis/[model]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/imoveis/[model]"])
      });
    }
  